import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function customModalReducer(state = initialState.customModal, action) {
	switch (action.type) {
		case types.CUSTOM_MODAL_SET: {
			let stateToUpdate = {
				isOpen: false,
				title: "",
				message: "",
				onCancel: null,
				onConfirm: null,
				handleUnsavedChanges: false
			};
			stateToUpdate = action.body;

			return stateToUpdate;
		}
		case types.CUSTOM_MODAL_RESET: {
			return {
				isOpen: false,
				title: "",
				message: "",
				onCancel: null,
				onConfirm: null,
				handleUnsavedChanges: false
			};
		}
		default:
			return state;
	}
}